import { SftpIngestMode } from "types/SftpPartner";

export const SFTP_TAB_PATH = "/integrations?tab=sftp";

export const sftpPartnerPath = (slug: string) =>
  `/integrations/sftp/${encodeURIComponent(slug)}`;

export const ingestModeLabel = (mode: SftpIngestMode) =>
  mode === "PULL" ? "Pull" : "Push";

const CLAIM_TYPE_LABELS: Record<string, string> = {
  INSTITUTIONAL: "Institutional",
  PROFESSIONAL_PROVIDER: "Professional",
  PROFESSIONAL_ANESTHESIA: "Anesthesia",
};

export const claimTypeLabel = (claimType: unknown): string => {
  if (typeof claimType !== "string" || !claimType) return "Unknown claim type";
  return CLAIM_TYPE_LABELS[claimType] || claimType;
};

/** `PRIMARY_PROVIDER` → `Primary provider`. */
export const humanizeEnum = (value: string | null | undefined): string => {
  if (!value) return "";
  const words = value.toLowerCase().split("_").join(" ");
  return words.charAt(0).toUpperCase() + words.slice(1);
};

/** "3 hours ago" style, for the list's Last file processed column (exact time on hover). */
export const relativeTime = (
  iso: string | null | undefined,
  now: Date = new Date()
): string => {
  if (!iso) return "";
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return iso;
  const seconds = Math.round((now.getTime() - then.getTime()) / 1000);
  if (seconds < 60) return "just now";
  const units: [number, string][] = [
    [60 * 60 * 24 * 365, "year"],
    [60 * 60 * 24 * 30, "month"],
    [60 * 60 * 24, "day"],
    [60 * 60, "hour"],
    [60, "minute"],
  ];
  const [size, unit] = units.find(([s]) => seconds >= s) || units[4];
  const n = Math.floor(seconds / size);
  return `${n} ${unit}${n === 1 ? "" : "s"} ago`;
};

// Rule fields shown in the rule's main line; everything else goes in "More settings".
export const RULE_HEADLINE_FIELDS = [
  "claimType",
  "providerId",
  "placeOfServiceFilter",
];

export interface IPayerTaxonomyRuleView {
  payerIds: number[];
  includeAll: boolean;
  taxonomies: string[];
}

export const isPayerTaxonomyRuleList = (
  value: unknown
): value is IPayerTaxonomyRuleView[] =>
  Array.isArray(value) &&
  value.every(
    (r) =>
      r &&
      typeof r === "object" &&
      Array.isArray((r as IPayerTaxonomyRuleView).payerIds) &&
      typeof (r as IPayerTaxonomyRuleView).includeAll === "boolean" &&
      Array.isArray((r as IPayerTaxonomyRuleView).taxonomies)
  );

export const describePayerTaxonomyRule = (r: IPayerTaxonomyRuleView) => {
  const payers = `Payer${r.payerIds.length === 1 ? "" : "s"} ${r.payerIds.join(
    ", "
  )}`;
  if (r.includeAll) return `${payers}: every rendering taxonomy`;
  if (!r.taxonomies.length) return `${payers}: no taxonomies (none priced)`;
  return `${payers}: only ${r.taxonomies.join(", ")}`;
};

/** RTK Query error → the server's message, for the toast. */
export const sftpApiErrorMessage = (error: unknown, fallback: string) => {
  const data = (error as { data?: { message?: unknown } })?.data;
  return typeof data?.message === "string" && data.message.length > 0
    ? data.message
    : fallback;
};
